import AccessEditor from './AccessEditor'
import AccessOrderEvents from './AccessOrderEvents'
import AccessOrders from './AccessOrders'
import AvailableServices from './AvailableServices'
import Subscriptions from './Subscriptions'
import Tickets from './Tickets'
import CharacteristicsWidget from './CharacteristicsWidget'

module.exports = {
  AccessEditor,
  AccessOrderEvents,
  AccessOrders,
  AvailableServices,
  Subscriptions,
  Tickets,
  CharacteristicsWidget
}



// WEBPACK FOOTER //
// ./src/projects/access-gui/components/access/index.js